module.exports = __webpack_public_path__ + "static/media/pyv-add-another-pyv.a6db5c14.gif";